import SimpleBar from 'simplebar'
import 'simplebar/dist/simplebar.css'
document.addEventListener('DOMContentLoaded',  () => {
  const articleTable = document.querySelector('.article-table__container')

  if(articleTable) {
    new SimpleBar(articleTable)
  }


  const articleHeadTitle = document.querySelector('.article-head__title')

  if(articleHeadTitle) {
    const breadcrumbs = document.querySelector('.breadcrumbs')
    if(breadcrumbs) {
      breadcrumbs.classList.add('breadcrumbs--article')

      const resize = () => {
        const left = articleHeadTitle.classList.contains('dealers-head__title') ? articleHeadTitle.closest('.dealers-head__content').offsetLeft : articleHeadTitle.offsetLeft
        breadcrumbs.style.setProperty('left', `${left}px`)
      }
      setTimeout(() => {
        resize()
      })
      window.addEventListener('resize', resize)
    }
  }
})
